import React, { useState } from "react";
import { Zap, Loader2, ShieldAlert, CheckCircle2 } from "lucide-react";
import { aiOneTap } from "../../api";
import { toast } from "sonner";

export default function OneTapTrade({ canTrade, onSent, onOpenSetup }) {
  const [busy, setBusy] = useState(false);
  const [last, setLast] = useState(null);

  const fire = async () => {
    setBusy(true);
    setLast(null);
    try {
      const r = await aiOneTap(0.7);
      setLast(r);
      if (r.sent) {
        toast.success(r.liveQueued ? `One-tap: ${r.setup.side} XAUUSD inviato LIVE a MT5` : `One-tap: ${r.setup.side} XAUUSD registrato (paper)`);
        onSent?.();
      } else {
        toast.warning("One-tap bloccato: " + r.blockers[0]);
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "AI non disponibile");
    } finally {
      setBusy(false);
    }
  };

  const s = last?.setup;
  return (
    <div data-testid="one-tap-panel" className="rounded-xl border border-fuchsia-400/25 bg-fuchsia-500/[0.06] p-3 space-y-2">
      <button
        data-testid="one-tap-trade-button"
        onClick={fire}
        disabled={busy || !canTrade}
        className="w-full flex items-center justify-center gap-2 py-3 rounded-lg text-[12px] font-extrabold uppercase tracking-wide text-white bg-gradient-to-r from-fuchsia-600 to-rose-500 hover:from-fuchsia-500 hover:to-rose-400 disabled:opacity-50 transition-colors shadow-[0_0_24px_rgba(217,70,239,0.25)]"
      >
        {busy ? <Loader2 size={15} className="animate-spin" /> : <Zap size={15} />}
        {busy ? "AI in analisi e invio…" : "AI compila e invia · 1 tap"}
      </button>
      <p className="text-[9px] text-slate-400 text-center">
        Invia a MT5 solo se entrambi i modelli concordano con confidenza ≥ 70%. Altrimenti niente ordine.
      </p>
      {last && (
        <div data-testid="one-tap-result" className={`text-[10px] rounded-lg px-3 py-2 border ${last.sent ? "border-emerald-400/30 bg-emerald-500/10 text-emerald-200" : "border-amber-400/30 bg-amber-500/10 text-amber-200"}`}>
          <div className="flex items-center gap-1.5 font-bold">
            {last.sent ? <CheckCircle2 size={12} /> : <ShieldAlert size={12} />}
            {last.sent ? `Segnale ${s.side} inviato` : "Nessun ordine inviato"}
            {s && <span className="font-mono font-normal text-slate-300">· {s.votes.map((v) => `${v.decision} ${Math.round(v.confidence * 100)}%`).join(" / ")}</span>}
          </div>
          {!last.sent && <ul className="mt-1 list-disc pl-4 space-y-0.5">{last.blockers.map((b, i) => <li key={i}>{b}</li>)}</ul>}
          {!last.sent && s && !s.fallback && (
            <button data-testid="one-tap-review-button" onClick={() => onOpenSetup?.(s)}
              className="mt-2 text-[10px] underline text-amber-100 hover:text-white">
              Rivedi il setup {s.side} nel form e decidi tu
            </button>
          )}
        </div>
      )}
    </div>
  );
}
